import Vue from 'vue';
import ElementUI from 'element-ui';

import DateShortCut from '@ui/DateShortCut/DateShortCut.vue';
import DateChooseYear from '@ui/DateShortCut/DateChooseYear.vue';
import CwCollapse from '@ui/Collapse/Collapse.vue';
import AgencyTree from '@ui/AgencyTree/AgencyTree';
import FontTip from '@ui/FontTip/FontTip';

Vue.component('date-short-cut', DateShortCut);
Vue.component('date-choose-year', DateChooseYear);
Vue.component('cw-collapse', CwCollapse);
Vue.component('agency-tree', AgencyTree);
Vue.component('font-tip', FontTip);

// 选择时间控件默认不可清空
ElementUI.DatePicker.mixins[0].props.editable.default = false;
ElementUI.DatePicker.mixins[0].props.clearable.default = false;
ElementUI.Pagination.props.layout.default = 'total, sizes, jumper, -> ,prev, pager, next';

Vue.use(ElementUI);

if (window.registerComponent) {
  window.registerComponent(Vue);
  window._hasRegister = true;
} else {
  if (window._hmt) {
    window._hmt.push(['_trackEvent', 'no-component-web']);
  }
}




// WEBPACK FOOTER //
// ./src/components/core/registerComponent.js